import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
export const StickyContactWrapper = ({ children, testId, variant, }) => {
    return (_jsx(Box, { display: {
            "breakpoint.base": "flex",
            "breakpoint.lg": "none",
        }, gap: "spacing.16", position: "fixed", bottom: "0", left: "0", right: "0", backgroundColor: variant === "light"
            ? "color.surface.default.default"
            : "color.background.constant.black", paddingVertical: "spacing.12", paddingHorizontal: {
            "breakpoint.base": "spacing.16",
            "breakpoint.sm": "spacing.32",
        }, borderTopStyle: "solid", borderTopWidth: "borderWidth.1", borderTopColor: "color.border.light.default", boxShadow: "shadow.8", zIndex: "zIndex.1", testId: testId, unsafe_className: "HideOnPrint", children: children }));
};
